// extracted by mini-css-extract-plugin
export default {"color_custom_loader":"colorLoader_color_custom_loader__R7Qug","s6":"colorLoader_s6__otYgs"};